/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { ExternalDocumentation } from '../../../core/models/common/ExternalDocumentation';
import { OasOperation } from '../../models/OasOperation';
import { OasParameter } from '../../models/OasParameter';
import { OasResponses } from '../../models/OasResponses';
import { OasSecurityRequirement } from '../../models/OasSecurityRequirement';

/**
 * Constructor.
 * @param {string} method
 * @class
 * @extends OasOperation
 * @author eric.wittmann@gmail.com
 */
export class Oas20Operation extends OasOperation {
    public consumes : Array<string>;

    public produces : Array<string>;

    public schemes : Array<string>;

    public constructor(method : string) {
        super(method);
        if(this.consumes===undefined) this.consumes = null;
        if(this.produces===undefined) this.produces = null;
        if(this.schemes===undefined) this.schemes = null;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasOperation#createParameter()
     * @return {OasParameter}
     */
    public createParameter() : OasParameter {
        let param : OasParameter = new Oas20Parameter();
        param._ownerDocument = this.ownerDocument();
        param._parent = this;
        return param;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasOperation#createResponses()
     * @return {OasResponses}
     */
    public createResponses() : OasResponses {
        let responses : OasResponses = new Oas20Responses();
        responses._ownerDocument = this.ownerDocument();
        responses._parent = this;
        return responses;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasOperation#createSecurityRequirement()
     * @return {OasSecurityRequirement}
     */
    public createSecurityRequirement() : OasSecurityRequirement {
        let requirement : OasSecurityRequirement = new Oas20SecurityRequirement();
        requirement._ownerDocument = this.ownerDocument();
        requirement._parent = this;
        return requirement;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.Operation#createExternalDocumentation()
     * @return {ExternalDocumentation}
     */
    public createExternalDocumentation() : ExternalDocumentation {
        let externalDocs : ExternalDocumentation = new Oas20ExternalDocumentation();
        externalDocs._ownerDocument = this.ownerDocument();
        externalDocs._parent = this;
        return externalDocs;
    }
}
Oas20Operation["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20Operation";
Oas20Operation["__interfaces"] = ["io.apicurio.datamodels.core.models.common.ISecurityRequirementParent","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.openapi.models.IOasParameterParent","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];





import { Oas20ExternalDocumentation } from './Oas20ExternalDocumentation';


import { Oas20SecurityRequirement } from './Oas20SecurityRequirement';


import { Oas20Responses } from './Oas20Responses';


import { Oas20Parameter } from './Oas20Parameter';

